import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
// import { Text } from 'recharts';
import CloseButon from '../../components/atoms/CloseButton';
import ShopContactInquiryStoreButton from '../../components/atoms/ShopContactInquiryStoreButton';
import ShopContactInquiryStripeButton from '../../components/atoms/ShopContactInquiryStripeButton';
import {
  getGroupIdentities,
  editIdentityGroupStatus
} from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '15%',
    left: '50%',
    transform: 'translate(-50%)',
    backgroundColor: '#fff',
    padding: 27,
    overflow: 'scroll',
    outline: 'none',
    borderRadius: 4
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  itemDiv: {
    margin: '20px auto'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 20
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    left: '-8px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupIdentities, editIdentityGroupStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('document', 'setDocument', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, setOpenShopContact }) => {
  const closeAction = () => {
    setOpenShopContact(false);
  };

  const openInquiryStoreAction = () => {
    console.log('Open form inquiry store');
  };

  const openInquiryStripeAction = () => {
    console.log('Open form inquiry stripe');
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.textTitle} align="center">
        お問い合わせ
      </Typography>
      <div className={classes.itemDiv}>
        <ShopContactInquiryStoreButton
          onClickAction={openInquiryStoreAction}
          href="https://share.hsforms.com/7433685/710b3bfa-103d-44d9-8ca8-0a0717ab5164"
        />
      </div>
      <div className={classes.itemDiv}>
        <ShopContactInquiryStripeButton
          onClickAction={openInquiryStripeAction}
          href="https://share.hsforms.com/7433685/b00dcf57-1d2e-45d1-a658-7d413573f038"
        />
      </div>
      {/* <div>
        <CloseButon className={classes.btnClose} onClickAction={closeAction} />
      </div> */}
      <CloseButon className={classes.btnClose} onClickAction={closeAction} />
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
